import ReactGA from 'react-ga';
import { subscriptionDatalayerValues } from '../utils/content'

export const logPage = () => {
	ReactGA.set({ page: window.location.pathname })
	ReactGA.pageview(window.location.pathname)
}

export const logEvent = (category = '', action = '') => {
	if (category && action) {
		ReactGA.event({ category, action })
	}
}

export const pushToDataLayer = (event, gaEventCategory, gaEventAction, gaEventLabel) => {
	if (typeof window !== 'undefined') {
		window.dataLayer.push({
			'event': event,
			'gaEventCategory': gaEventCategory,
			'gaEventAction': gaEventAction,
			'gaEventLabel': gaEventLabel
		})
	}
}

export const userIdDataLayer = (event, userId) => {
	if (typeof window !== 'undefined') {
		window.dataLayer.push({
			'event': event,
			'userId': userId
		})
	}
}

export const subscriptionDataLayer = (event, campaign, plan) => {
	if (typeof window !== 'undefined') {
		if(campaign && plan){
			const subData = subscriptionDatalayerValues()[campaign][plan];
			window.dataLayer.push({
				"event": event,
				"type": subData['type'],
				"value": subData['value'],
				"currency": "SEK"
			})
		}
	}
}